
<section class="main">

    <div class="">

        <div class="static" [innerHTML]="getSafeHtml(htmlContent)" ></div>

    </div>

</section>


<app-footer></app-footer>
